import { TrendingRoot } from "../cb/hashtags/trendingRoot"
import { setRoomAnimation } from "../cb/roomList"
import { BaseEntryPoint, exportEntryPoint } from "./base"
import type { IPageContext } from "../cb/interfaces/context"
import type { Gender } from "../common/genders"

export interface ITrendingContext extends IPageContext {
    genderList: Gender[]
    showLocation: boolean
}

exportEntryPoint(class Page extends BaseEntryPoint {
    protected context: ITrendingContext

    protected init(): void {
        super.init()
        setRoomAnimation(false) // Animation are not currently in use on trending page, so we force animations off.
        this.bindTrendingRoot()
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected parseContext(contextObj: Record<string, any>): void {
        super.parseContext(contextObj)
        this.context.genderList = contextObj["gender_list"] as Gender[]
        this.context.showLocation = contextObj["showLocation"]
    }

    private bindTrendingRoot(): void {
        if (document.getElementById("trending_root") !== null) {
            new TrendingRoot(this.context)
        }
    }
})
